import slice from './slice';

const { reducer } = slice;

export * from './actions';
export * from './api';
export * from './selectors';
export * from './types';
export { reducer as AnalyticsPageReducer };
